export const getRootUrl = () => global.baseUrl;

export const getAssetUrl = (name) =>
  `${getRootUrl()}/document-service/documents/static/${name}`;

export const getRootUrlSync = () => global.baseUrl;
